// Prepends https:// to links without a scheme; phone numbers (Call icon) and mailto:/tel: style links are left alone.
export const withHttps = (field) => {
  const link = (field.link || "").trim();
  if (!link || field.image?.includes("tell")) return field.link;

  // WhatsApp / Telegram: a bare number or @username becomes the standard share link.
  const isKnownHost = (re) => re.test(link);
  if (field.image?.includes("whatsapp") && !isKnownHost(/(^|[/@.])(wa\.me|wa\.link|whatsapp\.com)(\/|$)/i)) {
    const digits = link.replace(/[\s\-().+]/g, "");
    if (/^\d{7,15}$/.test(digits)) return "https://wa.me/" + digits;
  }
  if (field.image?.includes("telegram") && !isKnownHost(/(^|[/@.])(t\.me|telegram\.me|telegram\.org)(\/|$)|^tg:/i)) {
    const username = link.replace(/^@/, "");
    if (/^[A-Za-z0-9_]{3,}$/.test(username)) return "https://t.me/" + username;
  }
  if (/^[a-z][a-z0-9+.-]*:/i.test(link)) return link;
  return "https://" + link.replace(/^\/+/, "");
};

// True when every row has a title, a link and an icon (social rows) or an uploaded image (image rows).
export const linkFieldsComplete = (fields) =>
  fields.every((field) => {
    if (field.social_name === "") return false;
    if (field.link === "") return false;
    if (field.type === "image") return Boolean(field.image_path);
    return field.image !== "";
  });

// Body sent to POST /user/link: social rows are sent as-is, image rows carry the uploaded path instead of an icon.
export const toLinkPayload = (field) =>
  field.type === "image"
    ? { id: field.id, type: "image", social_name: field.social_name, link: withHttps(field), image_path: field.image_path }
    : { ...field, link: withHttps(field) };

// Maps a link returned by GET /user/link onto the editor's field shape.
export const fromApiLink = (element) =>
  element.type === "image"
    ? {
        id: element.id,
        type: "image",
        social_name: element.social_name,
        link: element.link,
        image_path: element.image_path,
        image_url: element.image_url,
        uploading: false,
        uid: Math.random().toString(36).slice(2),
      }
    : {
        id: element.id,
        social_name: element.social_name,
        image: element.icon,
        link: element.link,
      };
